/**
 * Taxonomia de cursos e áreas — base da personalização da Comunidade.
 *
 * Fonte: catálogo de graduação informado pelo usuário (2026-08-05), já
 * deduplicado: modalidade (Semipresencial), versão de currículo (2.0), grau
 * (- Licenciatura) e turmas de egressos foram removidos, porque para efeito de
 * CONTEÚDO não distinguem nada — 154 entradas viraram 126 cursos.
 *
 * ⚠️ O mapeamento curso → área vive AQUI, em código, e não no banco. No perfil
 * guarda-se o curso escolhido e as áreas de interesse; a área do curso é
 * derivada. Assim, reclassificar um curso não exige tocar em dado de usuário.
 *
 * ⚠️ Duas pendências conhecidas (ver docs/pendencias-etapa4-dados.md):
 *   · faltam 6 cursos do catálogo original (a lista recebida veio truncada
 *     entre "Enfermagem" e "Engenharia de Computação");
 *   · as 5 entradas "Formação Pedagógica para Graduados não Licenciados em X"
 *     foram mantidas como cursos próprios; se um dia forem fundidas às bases
 *     (Biologia, Filosofia, Geografia, História, Letras), a lista cai para 121.
 */

// ⚠️ As cores são usadas como FUNDO de chip com texto BRANCO. Todas foram
// verificadas contra o mínimo da WCAG para texto normal (4.5:1) — a paleta
// anterior (TOPICS em communityMockData) reprovava nas 9 cores, chegando a
// 1.38:1 no amarelo. Ao trocar qualquer uma, recalcular o contraste.
export const AREAS = [
  { id: 'saude', label: 'Saúde', icon: '⚕️', color: '#C2185B' },            // 5.87:1
  { id: 'tecnologia', label: 'Tecnologia', icon: '💻', color: '#1565C0' },  // 5.75:1
  { id: 'negocios', label: 'Negócios/Gestão', icon: '💼', color: '#00695C' }, // 6.61:1
  { id: 'humanas', label: 'Humanas/Licenciaturas', icon: '📚', color: '#6A1B9A' }, // 9.39:1
  { id: 'engenharias', label: 'Engenharias', icon: '⚙️', color: '#455A64' }, // 7.24:1
  { id: 'comunicacao', label: 'Comunicação/Design', icon: '🎨', color: '#BF360C' }, // 5.60:1
  { id: 'direito', label: 'Direito e Segurança', icon: '⚖️', color: '#4E342E' }, // 11.32:1
];

export const CURSOS = [
  { id: 'administracao', label: "Administração", area: 'negocios' },
  { id: 'administracao_publica', label: "Administração Pública", area: 'negocios' },
  { id: 'agronomia', label: "Agronomia", area: 'engenharias' },
  { id: 'analise_de_dados_de_alta_performance', label: "Análise de Dados de Alta Performance", area: 'tecnologia' },
  { id: 'analise_e_desenvolvimento_de_sistemas', label: "Análise e Desenvolvimento de Sistemas", area: 'tecnologia' },
  { id: 'arquitetura_e_urbanismo', label: "Arquitetura e Urbanismo", area: 'engenharias' },
  { id: 'artes_visuais', label: "Artes Visuais", area: 'humanas' },
  { id: 'banco_de_dados', label: "Banco de Dados", area: 'tecnologia' },
  { id: 'biomedicina', label: "Biomedicina", area: 'saude' },
  { id: 'ciberseguranca', label: "Cibersegurança", area: 'tecnologia' },
  { id: 'ciencia_da_computacao', label: "Ciência da Computação", area: 'tecnologia' },
  { id: 'ciencia_de_dados', label: "Ciência de Dados", area: 'tecnologia' },
  { id: 'ciencia_politica', label: "Ciência Política", area: 'humanas' },
  { id: 'ciencias_biologicas', label: "Ciências Biológicas", area: 'engenharias' },
  { id: 'ciencias_contabeis', label: "Ciências Contábeis", area: 'negocios' },
  { id: 'ciencias_economicas', label: "Ciências Econômicas", area: 'negocios' },
  { id: 'ciencias_sociais', label: "Ciências Sociais", area: 'humanas' },
  { id: 'coaching_e_mentoring', label: "Coaching e Mentoring", area: 'negocios' },
  { id: 'coding', label: "Coding", area: 'tecnologia' },
  { id: 'comercio_exterior', label: "Comércio Exterior", area: 'negocios' },
  { id: 'computacao_em_nuvem_powered_by_google_cloud', label: "Computação em Nuvem powered by Google Cloud", area: 'tecnologia' },
  { id: 'conciliacao_mediacao_e_arbitragem', label: "Conciliação, Mediação e Arbitragem", area: 'direito' },
  { id: 'criminologia', label: "Criminologia", area: 'direito' },
  { id: 'desenvolvimento_back_end', label: "Desenvolvimento Back-end", area: 'tecnologia' },
  { id: 'desenvolvimento_full_stack', label: "Desenvolvimento Full Stack", area: 'tecnologia' },
  { id: 'desenvolvimento_mobile', label: "Desenvolvimento Mobile", area: 'tecnologia' },
  { id: 'design_de_animacao', label: "Design de Animação", area: 'comunicacao' },
  { id: 'design_de_experiencia', label: "Design de Experiência", area: 'comunicacao' },
  { id: 'design_de_interiores', label: "Design de Interiores", area: 'comunicacao' },
  { id: 'design_de_moda', label: "Design de Moda", area: 'comunicacao' },
  { id: 'design_de_produto', label: "Design de Produto", area: 'comunicacao' },
  { id: 'design_grafico', label: "Design Gráfico", area: 'comunicacao' },
  { id: 'direito', label: "Direito", area: 'direito' },
  { id: 'educacao_especial', label: "Educação Especial", area: 'humanas' },
  { id: 'educacao_fisica', label: "Educação Física", area: 'saude' },
  { id: 'empreendedorismo', label: "Empreendedorismo", area: 'negocios' },
  { id: 'enfermagem', label: "Enfermagem", area: 'saude' },
  { id: 'engenharia_de_computacao', label: "Engenharia de Computação", area: 'engenharias' },
  { id: 'engenharia_de_producao', label: "Engenharia de Produção", area: 'engenharias' },
  { id: 'engenharia_de_software', label: "Engenharia de Software", area: 'engenharias' },
  { id: 'engenharia_eletrica', label: "Engenharia Elétrica", area: 'engenharias' },
  { id: 'engenharia_mecanica', label: "Engenharia Mecânica", area: 'engenharias' },
  { id: 'engenharia_mecatronica', label: "Engenharia Mecatrônica", area: 'engenharias' },
  { id: 'estetica_e_cosmetica', label: "Estética e Cosmética", area: 'saude' },
  { id: 'estudos_teoricos_psicanaliticos_e_sociais', label: "Estudos Teóricos Psicanalíticos e Sociais", area: 'humanas' },
  { id: 'eventos', label: "Eventos", area: 'negocios' },
  { id: 'farmacia', label: "Farmácia", area: 'saude' },
  { id: 'filosofia', label: "Filosofia", area: 'humanas' },
  { id: 'fisica', label: "Física", area: 'humanas' },
  { id: 'fisioterapia', label: "Fisioterapia", area: 'saude' },
  { id: 'fonoaudiologia', label: "Fonoaudiologia", area: 'saude' },
  { id: 'formacao_pedagogica_p_graduados_nao_licenciados_em_biologia', label: "Formação Pedagógica p/ Graduados não Licenciados em Biologia", area: 'humanas' },
  { id: 'formacao_pedagogica_para_graduados_nao_licenciados_em_filosofia', label: "Formação Pedagógica para Graduados não Licenciados em Filosofia", area: 'humanas' },
  { id: 'formacao_pedagogica_para_graduados_nao_licenciados_em_geografia', label: "Formação Pedagógica para Graduados não Licenciados em Geografia", area: 'humanas' },
  { id: 'formacao_pedagogica_para_graduados_nao_licenciados_em_historia', label: "Formação Pedagógica para Graduados não Licenciados em História", area: 'humanas' },
  { id: 'formacao_pedagogica_para_graduados_nao_licenciados_em_letras_portugues_e_ingles', label: "Formação Pedagógica para Graduados não Licenciados em Letras - Português e Inglês", area: 'humanas' },
  { id: 'fotografia', label: "Fotografia", area: 'comunicacao' },
  { id: 'gastronomia', label: "Gastronomia", area: 'negocios' },
  { id: 'geografia', label: "Geografia", area: 'humanas' },
  { id: 'gerontologia', label: "Gerontologia", area: 'saude' },
  { id: 'gestao_ambiental', label: "Gestão Ambiental", area: 'engenharias' },
  { id: 'gestao_comercial', label: "Gestão Comercial", area: 'negocios' },
  { id: 'gestao_da_producao_industrial', label: "Gestão da Produção Industrial", area: 'negocios' },
  { id: 'gestao_da_qualidade', label: "Gestão da Qualidade", area: 'negocios' },
  { id: 'gestao_da_saude_publica', label: "Gestão da Saúde Pública", area: 'saude' },
  { id: 'gestao_das_organizacoes_do_terceiro_setor', label: "Gestão das Organizações do Terceiro Setor", area: 'negocios' },
  { id: 'gestao_de_cooperativas', label: "Gestão de Cooperativas", area: 'negocios' },
  { id: 'gestao_de_negocios_imobiliarios', label: "Gestão de Negócios Imobiliários", area: 'negocios' },
  { id: 'gestao_de_recursos_humanos', label: "Gestão de Recursos Humanos", area: 'negocios' },
  { id: 'gestao_de_seguranca_privada', label: "Gestão de Segurança Privada", area: 'direito' },
  { id: 'gestao_de_tecnologia_da_informacao', label: "Gestão de Tecnologia da Informação", area: 'tecnologia' },
  { id: 'gestao_de_turismo', label: "Gestão de Turismo", area: 'negocios' },
  { id: 'gestao_desportiva_e_de_lazer', label: "Gestão Desportiva e de Lazer", area: 'saude' },
  { id: 'gestao_do_agronegocio', label: "Gestão do Agronegócio", area: 'engenharias' },
  { id: 'gestao_financeira', label: "Gestão Financeira", area: 'negocios' },
  { id: 'gestao_hospitalar', label: "Gestão Hospitalar", area: 'saude' },
  { id: 'gestao_publica', label: "Gestão Pública", area: 'negocios' },
  { id: 'historia', label: "História", area: 'humanas' },
  { id: 'influenciador_digital', label: "Influenciador Digital", area: 'comunicacao' },
  { id: 'inteligencia_artificial', label: "Inteligência Artificial", area: 'tecnologia' },
  { id: 'interdisciplinar_em_humanidades', label: "Interdisciplinar em Humanidades", area: 'humanas' },
  { id: 'internet_das_coisas', label: "Internet das Coisas", area: 'tecnologia' },
  { id: 'jogos_digitais', label: "Jogos Digitais", area: 'tecnologia' },
  { id: 'jornalismo', label: "Jornalismo", area: 'comunicacao' },
  { id: 'letras_libras', label: "Letras - LIBRAS", area: 'humanas' },
  { id: 'letras_portugues_e_espanhol', label: "Letras - Português e Espanhol", area: 'humanas' },
  { id: 'letras_portugues_e_ingles', label: "Letras - Português e Inglês", area: 'humanas' },
  { id: 'letras_portugues_e_japones', label: "Letras - Português e Japonês", area: 'humanas' },
  { id: 'logistica', label: "Logística", area: 'negocios' },
  { id: 'marketing', label: "Marketing", area: 'negocios' },
  { id: 'marketing_digital', label: "Marketing Digital", area: 'negocios' },
  { id: 'matematica', label: "Matemática", area: 'humanas' },
  { id: 'medicina', label: "Medicina", area: 'saude' },
  { id: 'medicina_veterinaria', label: "Medicina Veterinária", area: 'engenharias' },
  { id: 'naturologia', label: "Naturologia", area: 'saude' },
  { id: 'nutricao', label: "Nutrição", area: 'saude' },
  { id: 'odontologia', label: "Odontologia", area: 'saude' },
  { id: 'optica_e_optometria', label: "Óptica e Optometria", area: 'saude' },
  { id: 'pedagogia', label: "Pedagogia", area: 'humanas' },
  { id: 'pericia_judicial_e_extrajudicial', label: "Perícia Judicial e Extrajudicial", area: 'direito' },
  { id: 'podologia', label: "Podologia", area: 'saude' },
  { id: 'processos_gerenciais', label: "Processos Gerenciais", area: 'negocios' },
  { id: 'producao_audiovisual', label: "Produção Audiovisual", area: 'comunicacao' },
  { id: 'producao_cultural', label: "Produção Cultural", area: 'comunicacao' },
  { id: 'producao_midiatica', label: "Produção Midiática", area: 'comunicacao' },
  { id: 'psicologia', label: "Psicologia", area: 'saude' },
  { id: 'psicopedagogia', label: "Psicopedagogia", area: 'humanas' },
  { id: 'publicidade_e_propaganda', label: "Publicidade e Propaganda", area: 'comunicacao' },
  { id: 'quimica', label: "Química", area: 'humanas' },
  { id: 'radiologia', label: "Radiologia", area: 'saude' },
  { id: 'redes_de_computadores', label: "Redes de Computadores", area: 'tecnologia' },
  { id: 'relacoes_internacionais', label: "Relações Internacionais", area: 'humanas' },
  { id: 'relacoes_publicas', label: "Relações Públicas", area: 'comunicacao' },
  { id: 'secretariado', label: "Secretariado", area: 'negocios' },
  { id: 'seguranca_da_informacao', label: "Segurança da Informação", area: 'tecnologia' },
  { id: 'seguranca_no_trabalho', label: "Segurança no Trabalho", area: 'direito' },
  { id: 'seguranca_no_transito', label: "Segurança no Trânsito", area: 'direito' },
  { id: 'seguranca_publica', label: "Segurança Pública", area: 'direito' },
  { id: 'servico_social', label: "Serviço Social", area: 'humanas' },
  { id: 'servicos_juridicos_e_notariais', label: "Serviços Jurídicos e Notariais", area: 'direito' },
  { id: 'servicos_penais', label: "Serviços Penais", area: 'direito' },
  { id: 'sistemas_de_informacao', label: "Sistemas de Informação", area: 'tecnologia' },
  { id: 'sistemas_para_internet', label: "Sistemas para Internet", area: 'tecnologia' },
  { id: 'teologia', label: "Teologia", area: 'humanas' },
  { id: 'terapia_ocupacional', label: "Terapia Ocupacional", area: 'saude' },
  { id: 'terapias_integrativas_e_complementares', label: "Terapias Integrativas e Complementares", area: 'saude' },
];

const semAcento = (texto) =>
  String(texto || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

/** Área (id) do curso, ou null se o id não existir. */
export const getAreaDoCurso = (cursoId) =>
  CURSOS.find((c) => c.id === cursoId)?.area ?? null;

export const getCurso = (cursoId) => CURSOS.find((c) => c.id === cursoId) ?? null;
export const getArea = (areaId) => AREAS.find((a) => a.id === areaId) ?? null;

/**
 * Busca para o seletor por digitação.
 *
 * Três decisões que valem em pt-BR e não são detalhe:
 *  · compara SEM ACENTO dos dois lados ("quimica" acha "Química");
 *  · casa no MEIO da palavra ("software" acha "Engenharia de Software"), porque
 *    quem digita lembra da palavra que identifica o curso, não da primeira;
 *  · a partir de 2 caracteres — a lista é local, filtrar cedo não custa nada.
 */
export const buscarCursos = (termo) => {
  const alvo = semAcento(termo).trim();
  if (alvo.length < 2) return [];
  return CURSOS.filter((c) => semAcento(c.label).includes(alvo));
};
